export default __webpack_public_path__ + "static/media/include_4@3x.133783bf.jpg";